export class FileType {
  displayOrder: number;
  id: string;
  name: string;
  notifyExternalUserOnChange: boolean;
  notifyExternalUserOnStatusId: string;
  notifyInternalUserOnChange: boolean;
  notifyOnStatusId: string;
  blockFilesTabUpload?: boolean;
}
